export const frontmatter = {
    "draft": false,
    "title": "Planes",
    "description": "Gestión de planes en OnnIA.",
    "sidebar_label": "Planes",
    "sidebar_group": "referencia",
    "sidebar_order": 4
}

export const toc = []